import type { FilterConfigBarItemDefault } from '@rocco/ui/filter-sort/types/filter-config-bar';
import type { SingleValueFilterState } from '@rocco/ui/filter-sort/view-models/filter-state/single-value-filter-state';
import type { FilterBarElementProps } from '@rocco/ui/filter-sort/components/filters-bar/FiltersBarElement';
import { Checkbox as RoccoCheckbox } from '@rocco/components/checkbox';
import { Label as RoccoLabel } from '@rocco/components/label';

export const FiltersBarSingleValue = (
    props: FilterBarElementProps<
        FilterConfigBarItemDefault,
        SingleValueFilterState
    >,
) => {
    const { filterConfigItem, filterState, onFilterStateUpdate } = props;

    // Always show pills, even when count is 0
    return (
        <div
            className="hover:border- group flex h-8 cursor-pointer items-center rounded-2 border border-transparent px-2 hover:bg-primary-foreground hover:text-primary"
            onClick={() => {
                onFilterStateUpdate(
                    { ...filterState, checked: !filterState.checked },
                    true,
                );
            }}
        >
            <RoccoCheckbox
                id={filterConfigItem.filterKey}
                checked={filterState.checked}
                groupHover="light"
            />
            <RoccoLabel target="checkbox">{filterConfigItem.label}</RoccoLabel>
        </div>
    );
};
